module.exports = __webpack_public_path__ + "img/event2412_1.acc74932.png";